module.exports = __webpack_public_path__ + "static/Nina+Yujiri+Resume-584adea463bd1e9145e72606c4f9f73e.pdf";